module.exports = __webpack_public_path__ + "img/measurement_info_back_waist_left.86a5e147.jpg";